import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { Facs, HeaderTableFacsV2 } from 'src/app/core/models/facs.model';
import { SnackbarService } from '../snackbar/service/snackbar.service';
import { FacsService } from 'src/app/facs/service/facs.service';
import { HeaderTableFacs } from '../../../core/models/facs.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-dnd-table',
  templateUrl: './dnd-table.component.html',
  styleUrls: ['./dnd-table.component.scss']
})
export class DndTableComponent implements OnInit {

  @Output() public openTable = new EventEmitter<any>();
  @Output() public sendIndex = new EventEmitter<any>();
  @Output() public selectOptions = new EventEmitter<boolean>();
  @Output() public selectedItems = new EventEmitter<any>();

  public index = 1;
  public page: number;
  public id: number;
  public clickAction = 0;
  public countColumn = 0;
  public dataOrder = {};

  public loader: boolean;
  public listHeaders = [];
  public CONST_LIST = ['person.name', 'offered_products.name', 'funnel_stage.value', 'user.nickname', '', 'temperature.name'];
  public CONST_ASC = ['ASC', 'DESC'];

  public columnId = null;
  public isIndex = false;
  public isOrder = false;
  public featureV2 = false;
  public isCheckbox = false;
  public selectAllItems = false;
  public itemsSelected = [];
  public listBinding = [];

  @Input() public clearOrder: number;

  constructor(
    private snackService: SnackbarService,
    private service: FacsService,
    private environmentService: EnvironmentService,
  ) { }

  ngOnInit() {
    this.featureV2 = this.environmentService.getEnvVar('feature_table') === 'true';
    this.isCheckbox = this.environmentService.getEnvVar('feature_facs_table_checkbox') === 'true';
    this.startHeader();
    this.service.getOpen().subscribe(x => this.isIndex = x);
    this.service.getList().subscribe(resp => {
      if (this.clearOrder) {
        this.countColumn = 0;
      }
      if (this.featureV2) {
        if ((resp && resp.page_info && (resp.page_info.page_number === 0 || resp.page_info.page_number === 1)) || this.isOrder) {
          this.isOrder = true;
          this.index = 1;
          this.listBinding = [];
        }
      } else {
        if (resp && resp.page_info && (resp.page_info.page_number === 0 || resp.page_info.page_number === 1)) {
          this.listBinding = [];
        }
      }
      resp.payload.forEach((x: { facs: Facs[]; }) => x.facs.forEach((data: Facs) => this.listBinding.push(data)));
      this.listBinding = [...new Set(this.listBinding)];
      this.page = resp.page_info && resp.page_info.total_pages;
      this.loader = false;
      this.isOrder = false;
    });
  }

  private startHeader() {
    this.listHeaders = this.featureV2 ? HeaderTableFacsV2 : HeaderTableFacs;
  }

  public hoverEvent(event: number) {
    this.id = event + 1;
  }

  public copyToClipboard(item: string, type: string): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    this.snackService.show(`${type} copiado`, 'success');
  }

  public openModalTable(event: Event, flag: boolean, data) {
    event.stopPropagation();
    if (flag) {
      this.openTable.emit({
        id: data.id,
        openModal: flag,
        column: {
          value: data.funnel_stage.value,
          sub_items: []
        }
      });
    } else {
      return false;
    }
  }

  public getScroll(event: Event | any) {
    event.preventDefault();
    const heigth = ((100 * event.srcElement.scrollTop) / (event.srcElement.scrollHeight - event.srcElement.clientHeight));
    if (heigth >= 99) {
      if (this.loader) {
        return;
      } else {
        this.index += 1;
        if (this.index <= this.page) {
          this.loader = true;
          if (this.featureV2) {
            this.sendIndex.emit({
              index: this.index,
              data: this.dataOrder
            });
          } else {
            this.sendIndex.emit(this.index);
          }
        }
      }
    }
  }

  public finishedLoader(dataIndex: number) {
    if (dataIndex >= this.page) {
      return false;
    }
  }

  public actionHeader(event: Event | any, i: number) {
    if (i === null) {
      return;
    }
    if (i !== 0) {
      event.stopPropagation();
      this.requestColumn(i);
      this.requestOrder();
    }
  }

  public requestColumn(i: number) {
    if (i === null) {
      return;
    }
    if (this.columnId !== i) {
      this.countColumn = 0;
    }
    this.columnId = i;
    this.countColumn += 1;
    if (this.countColumn > 2) {
      this.countColumn = 0;
    }
  }

  public requestOrder() {
    if (this.columnId === 1 || this.columnId === 2 || this.columnId === 3 || this.columnId === 4 || this.columnId === 6) {
      this.isOrder = true;
      this.selectAllItems = false;
      this.selectOptions.emit(false);
      this.dataOrder = {
        order: [{
          field: this.CONST_LIST[this.columnId - 1],
          sort: this.CONST_ASC[this.countColumn - 1],
        }],
        listLength: 50
      };
      this.sendIndex.emit({
        index: 1,
        data: this.dataOrder
      });
    }
  }

  public selectAll() {
    if (this.isOrder) {
      return;
    } else {
      this.selectAllItems = !this.selectAllItems;
      this.listBinding.forEach(x => x.select = this.selectAllItems);
      if (this.selectAllItems) {
        if (this.itemsSelected.length === 0) {
          this.listBinding.forEach(fac => {
            this.itemsSelected.push(fac.id);
          });
        } else {
          this.listBinding.forEach(fac => {
            let exists = this.itemsSelected.includes(fac.id);
            if (!exists) {
              this.itemsSelected.push(fac.id);
            }
          });
        }
      } else {
        this.itemsSelected = [];
      }
      this.sendOpen(this.selectAllItems);
      this.selectedItems.emit(this.itemsSelected);
    }
  }

  public getClickItem(index: number): void {
    this.listBinding[index].select = !this.listBinding[index].select;
    this.listBinding.forEach((x, i) =>  {
      if (i === index) {
        if (!x.select) {
          this.itemsSelected.push(x.id);
        } else {
          let index = this.itemsSelected.indexOf(x.id, 0);
          this.itemsSelected.splice(index, 1);
        }
        x.select = !x.select;
      }
    });
    this.sendOpen(this.listBinding.filter(x => x.select).length >= 1);
    this.selectedItems.emit(this.itemsSelected);
  }

  public sendOpen(data: boolean): void {
    if (data) {
      this.selectOptions.emit(true);
    } else {
      this.selectOptions.emit(false);
    }
  }

}
